import { Location, NgPlural, NgPluralCase } from '@angular/common';
import { Component, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { User } from 'src/app/models/data/user';
import { NavigationHistoryService } from 'src/app/services/navigation-history.service';
import {
	CreateRoleRequestStatus,
	CreateRoleRequestStatusEvent,
	EditRole,
} from 'src/app/ui/roles/add-role/add-role-main-tab.component';
import { MatDivider } from '@angular/material/list';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatButton } from '@angular/material/button';

@Component({
	selector: 'app-add-role-confirmation',
	templateUrl: './add-role-confirmation.component.html',
	styleUrls: [
		'./add-role-confirmation.component.scss',
		'../../../common/main.scss',
	],
	imports: [MatDivider, MatProgressSpinner, MatButton, NgPlural, NgPluralCase],
})
export class AddRoleConfirmationComponent implements OnInit {
	@Input()
	createRoleRequestStatusEvent!: Observable<CreateRoleRequestStatusEvent>;
	@Input() companyId?: string;
	@Input() isActiveCompany = false;

	// @Output() confirmationTabEvent = new EventEmitter<boolean>();
	showLoading = false;
	showSuccess = false;
	showFailure = false;
	users: User[] = [];
	roleName = '';

	constructor(
		private readonly router: Router,
		private readonly location: Location,
		private readonly navHistory: NavigationHistoryService
	) {}

	ngOnInit(): void {
		this.createRoleRequestStatusEvent.subscribe((event) => {
			this.showLoading = false;
			this.showSuccess = false;
			this.showFailure = false;

			this.roleName = event?.data?.roleName ?? '';
			this.users = event?.data?.users ?? [];

			switch (event.status) {
				case CreateRoleRequestStatus.loading:
					this.showLoading = true;
					break;
				case CreateRoleRequestStatus.success:
					this.showSuccess = true;
					break;
				case CreateRoleRequestStatus.failure:
					this.showFailure = true;
					break;
			}
		});
	}

	returnToRoles(): void {
		if (this.isActiveCompany || !this.companyId) {
			this.router.navigateByUrl('/roles');
		} else {
			this.navHistory.navigateBack();
		}
	}
}
